import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { media } from 'ui';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-bottom: 4px;

  & > * {
    margin-right: 10px;
  }
  ${media.tablet`
    flex-wrap: wrap;
    margin: 10px 0;
  `};
`;

const ActionButtons = ({ children }) =>
  <Wrapper>
    {children}
  </Wrapper>;

ActionButtons.propTypes = {
  children: PropTypes.node,
};

export default ActionButtons;
